module.exports = __webpack_public_path__ + "img/025.0095b62d.jpg";